import React from 'react';
import PropTypes from 'prop-types';
import { Page } from '../../components';
import ContentForm from './ContentForm';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
export default function NewContent(props) {
  const { match: { params: { carrierId } }, history } = props;

  const handleSaveComplete = (content) => {
    let redirectHref = `/contents/${content.id}`;
    if (content.carrierId) {
      redirectHref = `/carriers/${content.carrierId}/contents/${content.id}`;
    }
    history.push(redirectHref);
  };

  let breadcrumbsHref = '/contents';
  if (carrierId) {
    breadcrumbsHref = `/carriers/${carrierId}/contents`;
  }

  return (
    <Page
      breadcrumbs={[{ content: 'Content', href: breadcrumbsHref }]}
      title="Create Content"
    >
      <ContentForm onSaveComplete={handleSaveComplete} />
    </Page>
  );
}
NewContent.propTypes = propTypes;
